export const REQUEST_GET_LENDERS = 'REQUEST_GET_LENDERS';
export const RECEIVE_GET_LENDERS = 'RECEIVE_GET_LENDERS';
export const RECEIVE_GET_LENDERS_ERROR = 'RECEIVE_GET_LENDERS_ERROR';
